import store from '@/store'

function checkPermission(el, binding) {
  const { value } = binding

  if(store.getters.authMap) {
    const hasPermission = store.getters.authMap[value]
  
    if (!hasPermission) {
      el.parentNode && el.parentNode.removeChild(el)
    }
  }
}

export default {
  inserted(el, binding) {
    checkPermission(el, binding)
  },
  update(el, binding) {
    checkPermission(el, binding)
  }
}
